import { watch, nextTick, onBeforeUnmount, type Ref } from 'vue';
import { useDraggable, type UseDraggableReturn } from 'vue-draggable-plus';
import type { FormElement } from '../model/form.types';

export function useCanvasDraggable(
  elementsContainer: Ref<HTMLElement | null>,
  elements: Ref<FormElement[]>,
  elementRefs: Ref<Map<string, HTMLElement>>,
  hasElements: Ref<boolean>,
  enabled: Ref<boolean>
) {
  let draggable: UseDraggableReturn | null = null;

  watch(
    [() => hasElements.value, () => enabled.value],
    async ([hasElements, isEnabled]) => {
      if (!hasElements || !isEnabled) {
        draggable?.destroy();
        draggable = null;
        return;
      }

      await nextTick();

      if (elementsContainer.value && !draggable) {
        draggable = useDraggable(elementsContainer, elements, {
          animation: 150,
          handle: '.drag-handle',
          ghostClass: 'opacity-50',
          dragClass: 'shadow-2xl',
          onEnd: () => {
            nextTick(() => {
              elementRefs.value = new Map(elementRefs.value);
            });
          },
        });
      }
    },
    { immediate: true }
  );

  watch(
    () => elements.value.length,
    () => {
      elementRefs.value = new Map(elementRefs.value);
    },
    { flush: 'post' }
  );

  onBeforeUnmount(() => {
    draggable?.destroy();
  });
}
